import React, { useState, useEffect } from 'react';

const ManagerProfile = () => {
    return ( <div>
        
    </div> );
}
 
export default ManagerProfile;